import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatEUR } from '@/lib/revenuePricing';

interface MonthRow {
  month: string;
  subscriptions: number;
  topups: number;
  total: number;
  topupCount: number;
}

interface RevenueChartProps {
  data: MonthRow[];
}

function formatMonth(key: string) {
  // "2026-04" → "Apr"
  const [_, m] = key.split('-');
  const idx = parseInt(m, 10) - 1;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[idx] ?? key;
}

export function RevenueChart({ data }: RevenueChartProps) {
  return (
    <Card className="app-tile">
      <CardHeader>
        <CardTitle className="text-lg">Monthly Revenue</CardTitle>
        <CardDescription>Subscriptions and top-ups, last 12 months</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 8, right: 8, left: -8, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
              <XAxis
                dataKey="month"
                tickFormatter={formatMonth}
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickFormatter={(v) => `€${v}`}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 'var(--radius)',
                  fontSize: 12,
                }}
                formatter={(value: number, name: string) => [formatEUR(value), name]}
                labelFormatter={(label: string) => formatMonth(label)}
              />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="subscriptions" stackId="a" fill="hsl(var(--primary))" name="Subscriptions" radius={[0, 0, 0, 0]} />
              <Bar dataKey="topups" stackId="a" fill="hsl(var(--accent))" name="Top-ups" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
